/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

export function usePaginate(data, deps, pageSize = 10) {
  const [showingItems, setShowingItems] = useState(pageSize);
  const [dataLength, setDataLength] = useState(0);

  useEffect(() => {
    setShowingItems(pageSize);
  }, [deps]);

  useEffect(() => {
    if (data) {
      setDataLength(Object.keys(data).length);
    } else {
      setDataLength(0);
    }
  }, [data]);

  const handlePage = () => {
    if (data) {
      if (dataLength - showingItems >= pageSize) {
        setShowingItems(showingItems + pageSize);
      } else {
        setShowingItems(showingItems + (dataLength - showingItems));
      }
    }
  };

  const PaginateBtn = () => {
    if (showingItems !== dataLength && dataLength > pageSize) {
      return (
        <button
          className="text-sm font-medium show-more mt-5 relative focus:outline-none flex items-center pointer-events-auto"
          onClick={handlePage}
        >
          show more
        </button>
      );
    }
  };

  return {
    showingItems,
    PaginateBtn,
  };
}
